import { useFeatureFlagContext } from '@core/providers/FeatureFlagProvider';

export function useFeatureFlags() {
  const { featureFlags, toggleFeatureFlag, resetFeatureFlags } = useFeatureFlagContext();

  return {
    featureFlags,
    toggleFeatureFlag,
    resetFeatureFlags,
  };
}
